module.exports = __webpack_public_path__ + "static/media/notification_notice_icon.890b128b.svg";